// Admin-only TipTap feature presets + merge helper.
//
// This file is intentionally JS (not TS) to match existing admin tooling.

const deepMerge = (base, override) => {
  if (!override) return base;
  if (Array.isArray(base) || Array.isArray(override)) return override ?? base;
  if (base && typeof base === 'object' && override && typeof override === 'object') {
    const out = { ...base };
    Object.keys(override).forEach((key) => {
      out[key] = deepMerge(base[key], override[key]);
    });
    return out;
  }
  return override ?? base;
};

export const ADMIN_TIPTAP_PRESETS = {
  posts: {
    toolbarMode: 'full',
    links: true,
    mentions: true,
    markdown: true,
    tables: true,
    tasks: true,
    codeBlocks: true,
    textAlign: true,
    superscript: true, // post-like editors only; not comments or announcements

    // Media + upload nodes
    media: true, // image/video nodes + captions + media UI
    files: true, // file upload node

    // Resource rows / modals (download rows, external link rows, meetings, resource table)
    resources: true,

    // Paste YouTube/Vimeo URLs to embed (without opening resource UI).
    pasteVideoEmbeds: true,

    // Intercept paste (files, generic URLs) to open resource modals - keep disabled by default.
    pasteResourceHandler: false,
  },

  announcements: {
    toolbarMode: 'simple',
    links: true,
    mentions: false,
    markdown: true,
    tables: false,
    tasks: false,
    codeBlocks: false,
    textAlign: false,

    media: false,
    files: false,
    resources: false,

    pasteResourceHandler: false,
  },

  comments: {
    toolbarMode: 'simple',
    links: true,
    mentions: true,
    markdown: true,
    tables: false,
    tasks: false,
    codeBlocks: false,
    textAlign: false,

    media: false,
    files: false,
    resources: false,

    pasteResourceHandler: false,
  },

  academy_posts: {
    toolbarMode: 'full',
    links: true,
    mentions: true,
    markdown: true,
    tables: true,
    tasks: true,
    codeBlocks: true,
    textAlign: true,
    superscript: true,

    media: true,
    files: true,
    resources: true,

    pasteVideoEmbeds: true,
    pasteResourceHandler: false,
  },
};

export const resolveAdminTiptapFeatures = ({ preset = 'posts', override = {} } = {}) => {
  const base = ADMIN_TIPTAP_PRESETS[preset] || ADMIN_TIPTAP_PRESETS.posts;
  return deepMerge(base, override);
};

